import { API_URL } from '../../@jumbo/constants/AppConstants';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import axios from 'axios';
import {
  ADD_FORNITORE,
  DELETE_BULK_FORNITORI,
  DELETE_FORNITORE,
  EDIT_FORNITORE,
  GET_FORNITORI,
  SET_FORNITORE_DETAILS,
} from '../../@jumbo/constants/ActionTypes';

export const getUsers = (filterOptions = [], searchTerm = '', callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    axios
      .get(API_URL + '/getFornitori.php', {
        params: { filterOptions, searchTerm },
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_FORNITORI, payload: data.data });
          if (callbackFun) callbackFun(data.data);
        } else {
          dispatch(fetchError('There was something issue in responding server.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};

export const setCurrentUser = user => {
  return dispatch => {
    dispatch({ type: SET_FORNITORE_DETAILS, payload: user });
  };
};

export const addNewUser = (user, callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    axios
      .post(API_URL + '/addNewFornitore.php', user)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('Nuovo fornitore aggiunto con successo!'));
          dispatch({ type: ADD_FORNITORE, payload: data.data });
          if (callbackFun) callbackFun(data.data);
        } else {
          dispatch(fetchError('Problema con la risposta del server'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Problema di rete'));
      });
  };
};

export const sentMailToUser = () => {
  return dispatch => {
    dispatch(fetchError('Email non presente'));
  };
};

export const updateUser = (user, callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    axios
      .put(API_URL + '/updateFornitore.php', user)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('Fornitore aggiornato con successo!'));
          dispatch({ type: EDIT_FORNITORE, payload: data.data });
          if (callbackFun) callbackFun(data.data);
        } else {
          dispatch(fetchError('There was something issue in responding server.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};

export const updateUserStatus = (data, callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    axios
      .put('/users/update-status', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchSuccess('Fornitore status was updated successfully.'));
          dispatch({ type: EDIT_FORNITORE, payload: response.data });
          if (callbackFun) callbackFun(response.data);
        } else {
          dispatch(fetchError('There was something issue in responding server.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};

export const deleteBulkUsers = (userIds, callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    axios
      .put('/users/bulk-delete', { userIds })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchSuccess('Selected users were deleted successfully.'));
          dispatch({ type: DELETE_BULK_FORNITORI, payload: userIds });
          if (callbackFun) callbackFun();
        } else {
          dispatch(fetchError('There was something issue in responding server.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};

export const deleteUser = (userId, callbackFun) => {
  console.log('deleteUser', userId);
  return dispatch => {
    dispatch(fetchStart());
    axios
      .delete(API_URL + '/eliminaFornitore.php', {
        params: { id: userId },
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('Fornitore cancellato con successo!'));
          dispatch({ type: DELETE_FORNITORE, payload: userId });
          if (callbackFun) callbackFun();
        } else {
          dispatch(fetchError('There was something issue in responding server.'));
        }
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};
